import React, { useEffect, useState, useContext } from "react";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import AddIcon from "@material-ui/icons/Add";
import CustomPagination from "../../../cm_shared/CMCustomPagination";
import { LoadingContext } from "../../../../../context/spinnerContext";
import { Tooltip, IconButton } from "@material-ui/core";
import CheckCircleSharpIcon from "@material-ui/icons/CheckCircleSharp";
import WarningIcon from "@material-ui/icons/Warning";
import DataTable from "react-data-table-component";
import axios from "axios";

const customStyles = {
  table: {
    style: {
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      minHeight: "72px",
      cursor: "pointer",
      fontSize: 16,
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      justifyContent: "flex-start",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "flex-start",
    },
  },
};
function PRLogicalBasedScenarios(props) {
  const { setIsLoading } = useContext(LoadingContext);
  const [columns, setColumns] = useState([]);
  const [tableData, setTableData] = useState([]);
  const rowsPerPageSessionBased = [
    10, 20, 50, 100, 200, 300, 500, 700, 1000, 1200, 1500, 1800, 2000, 2500,
    3000,
  ];
  const [eventsPerPage, setEventsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const initialColumns = [
    {
      name: "Scenario Name",
      selector: "scenario_name",
      grow: 3,
      sortable: true,
      cell: (row) => {
        return <>{row.scenario_name}</>;
      },
    },
    {
      name: "Vehicle ID",
      selector: "vehicle_id",
      sortable: true,
      cell: (row) => {
        return <>{row.vehicle_id}</>;
      },
    },
    {
      name: "Mapped Status",
      selector: "input_scenario_mapping",
      sortable: true,
      cell: (row) => (
        <div style={{ display: "flex" }}>
          {row.input_scenario_mapping ? (
            <CheckCircleSharpIcon style={{ color: "#b0ff45" }} />
          ) : (
            <Tooltip
              placement="top"
              title={<h6>Input scenario not mapped</h6>}
            >
              <WarningIcon style={{ color: "#ffcc00" }} />
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      name: "Region",
      selector: "region",
      sortable: true,
      cell: (row) => {
        return <>{row.region}</>;
      },
    },
    {
      name: "Remarks",
      selector: "remark",
      grow: 2,
      sortable: true,
      cell: (row) => {
        return <>{row.remark}</>;
      },
    },
    {
      name: "Updated At",
      selector: "updated_at",
      sortable: true,
      cell: (row) => {
        return <>{row.updated_at}</>;
      },
    },
    {
      name: "Actions",
      selector: "actions",
      sortable: false,
      cell: (row) => {
        const isInCart = props.cartItems.some(
          (item) => item.scenario_uuid === row.scenario_uuid
        );
        return (
          <div>
            <Tooltip
              placement="top"
              title={
                isInCart ? <h6>Remove from Cart</h6> : <h6>Add to Cart</h6>
              }
            >
              <IconButton
                aria-label={isInCart ? "remove" : "add"}
                disabled={props.statusValue === "bad"}
                onClick={() =>
                  isInCart ? props.removeFromCart(row) : props.addToCart(row)
                }
              >
                {isInCart ? <RemoveCircleIcon /> : <AddIcon />}
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    },
  ];
  const handleChangeRowsPerPage = (event) => {
    setEventsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  const handleSort = (column, direction) => {
    console.log(column);
    console.log(direction);
    setSortField(column.selector);
    setSortOrder(direction);
  };
  const getPRlogicalData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post("cm/reporting-mode/pr-listing", {
        page_number_record: page + 1,
        page_size_record: eventsPerPage,
        timestamp: props.data.date_from_folder,
      });
      setTableData(response.data.data);
      setTotal(response.data["total_records"]);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    setColumns(initialColumns);
  }, [props.cartItems]);
  useEffect(() => {
    getPRlogicalData();
  }, [eventsPerPage, page]);
  return (
    <div
      style={{
        padding: "1rem",
        background: "white",
        borderRadius: "10px",
      }}
    >
      <div
        style={{
          border: "solid 1px rgba(0,0,0,.5)",
          borderRadius: "10px",
        }}
      >
        <CustomPagination
          fromTestLevelReportingMode={true}
          total={total}
          rowsPerPageOptions={rowsPerPageSessionBased}
          eventsPerPage={eventsPerPage}
          page={page}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          onPageChange={handlePageChange}
        />
        {columns.length > 0 ? (
          <DataTable
            onSort={handleSort}
            sortServer
            columns={columns}
            data={tableData}
            customStyles={customStyles}
          ></DataTable>
        ) : null}
      </div>
    </div>
  );
}
export default PRLogicalBasedScenarios;
